import { Editor } from '@monaco-editor/react';
import React, { useRef, useState, useEffect } from 'react';
import { CODE_SNIPPETS } from '../../constants/Constant';
import axios from 'axios';
import CircularProgress from '@mui/material/CircularProgress';
import suggestions from "./suggestions";
import Chatbot from '../Chatbot/Chatbot';
import RefineCodeEditor from './RefineCodeEditor';
import SEO from '../../SEO';
import {useNavigate,useLocation } from 'react-router-dom';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AutoStoriesIcon from '@mui/icons-material/AutoStories';
import TemporaryDrawer from './Drawer';

const Compiler = () => {
  const navigate = useNavigate();
  const [value, setValue] = useState('');
  const [language, setLanguage] = useState('java');
  const editorRef = useRef();
  const [response, setResponse] = useState(null);
  const [loading, setLoading] = useState(false);  const [showPopup, setShowPopup] = useState(false);
  const [refinedCode, setRefinedCode] = useState("");
  const [loadingCard, setLoadingCard] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const codeFromURL = queryParams.get("code");
  const languageFromURL = queryParams.get("language");
  console.log(codeFromURL,languageFromURL);

useEffect(() => {
  if (codeFromURL) {
    setValue(decodeURIComponent(codeFromURL));
  }
  if (languageFromURL) {
    setLanguage(languageFromURL.toLowerCase());
  }
}, [codeFromURL, languageFromURL]);


const toggleDrawer = (newOpen) => () => {
  setDrawerOpen(newOpen);
};

  const onSelect = (e) => {
    const selectedLanguage = e.target.value;
    setLanguage(selectedLanguage);
    setValue(CODE_SNIPPETS[selectedLanguage] || ''); 
  };

  const onMount = (editor,monaco) => {
    editorRef.current = editor;
    editor.focus();
    const createCompletionProvider = (language, suggestions) => {
      monaco.languages.registerCompletionItemProvider(language, {
        provideCompletionItems: () => ({ suggestions }),
      });
    };

    // Apply suggestions for each language
    Object.keys(suggestions).forEach((lang) => {
      createCompletionProvider(lang, suggestions[lang]);
    });
 
  };

  const handleExecute = async () => {
    try {
      setLoading(true);
      const url = `${process.env.REACT_APP_COMPILER_URL}/execute/`;
      const codeToExecute = editorRef.current?.getValue() || value; 
      const response = await axios.post(url, {
        code: codeToExecute,
        language,
      }, {
        headers: {
          "X-API-Key": process.env.REACT_APP_COMPILER_API_KEY
        }
      });
      setResponse(response.data);
    } catch (error) {
      console.error('Error executing code:', error);
    } finally {
      setLoading(false);
    }
  };

  
  const refineCode = async () => {

    setLoadingCard(true);
    try {
      
      const originalCode = editorRef.current?.getValue();
      
      const refine = `
      Refine the following code, providing only the correct code as output. Include short comments inside the code to explain:
      1. What errors were present in the original code.
      2. How each error was fixed.
      
      Keep the explanations concise and to the point. Do not include any detailed explanations, notes, or non-code content inside the code.
      
      Original Code:
      ${originalCode}
      
      Output of the Original Code:
      ${response?.result}
      
      Identify any errors or issues in the code, fix them, and provide the corrected version with short comments explaining the errors and fixes.
      `;
      
      const airesponse = await axios.post(
        "https://backend.chat.duoples.com/chatbot/interact/",
        { question: refine },
        {
          headers: {
            Authorization: `api-key ${process.env.REACT_APP_CHATBOT_API_KEY}`,
            "Content-Type": "application/json",
          },
        }
      );
  

      const refinedCode = airesponse.data.answer;
      setShowPopup(true);
      setRefinedCode(refinedCode);
    } catch (error) {
      console.error("Error refining code:", error);
    } finally {
      setLoadingCard(false);
    }
  };

  const onSaveData = async () => {
    try {
      const title = prompt("Enter a title for your file:");
      if (!title) {
        toast.error("Title is required!");
        return;
      }
  
      const token = localStorage.getItem("accessToken");
      if (!token) {
        console.log("User not authenticated");
        navigate("/login-register");
        return;
      }
  
      const url = `${process.env.REACT_APP_API_URL}/api/user-results`;
      const codeToSave = editorRef.current?.getValue() || value;
  
      const user = JSON.parse(localStorage.getItem("user"));
      if (!user || !user.id || !user.email) {
        console.error("User data is missing:", user);
        return;
      }
  
      await toast.promise(
        axios.post(
          url,
          {
            data: {
              title,
              code_execution: codeToSave,
              code_output: response?.result || "No output available",
              language,
              user_id: user.id,
              email: user.email,
            },
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        ),
        {
          pending: "Saving data...",
          success: "Data saved successfully!",
          error: "Failed to save data. Please try again.",
        }
      );
    } catch (error) {
      console.error("Error executing code:", error);
      toast.error("An error occurred while saving.");
    }
  };
  
  

  return (
    <>
     <SEO
      title="Learn Hacking & Programming Online – Free Courses at PPDDEH"
      description="Master hacking and programming online for free with PPDDEH. Access expert-led courses on cybersecurity, coding, and ethical hacking today!"
      url="https://www.ppddeh.com/compiler"
    />
    <div className='h-fit relative'>
      {/* Options and button */}
      <div className='w-full h-fit bg-gray-800 flex p-2 justify-between items-center max-sm:flex-col '>

        <div className='pl-4  h-10 w-40 rounded-md items-center text-white cursor-pointer flex max-sm:w-full border-2' onClick={toggleDrawer(true)}>
          <AutoStoriesIcon /> <div className='text-lg font-semibold text-white ml-2'>Saved Data</div>
          </div>
       
        <div className='flex items-center max-sm:w-full'>
          
          <select className='w-60 h-10 rounded-lg p-2 m-2 outline-none max-sm:w-full' value={language} onChange={onSelect}>
            <option>python</option>
            <option>java</option>
            <option>c</option>
            <option>go</option>
          </select>

            <button className='w-32 bg-blue-500 text-white p-2 rounded-lg m-2 max-sm:w-1/2' onClick={refineCode} disabled={loadingCard}> {loadingCard ? <CircularProgress size="20px" color='white'/> : 'Refine Code'}</button>
          <button className='w-20 bg-blue-500 text-white p-2 rounded-lg m-2 max-sm:w-1/2' onClick={handleExecute} disabled={loading}>
            {loading ? <CircularProgress size="20px" color='white'/> : 'Run'}
          </button>
          <button  onClick={onSaveData} className='w-20 bg-blue-500 text-white p-2 rounded-lg m-2 max-sm:w-1/2'>Save</button>
        
        </div>
      </div>
      
      {/* Compiler Container */}
      <div className='w-full h-fit bg-gray-800 p-2 flex flex-col gap-2 lg:flex-row relative'>
        <div className='h-[350px] sm:h-[450px] lg:h-[580px] w-full rounded-3xl lg:w-3/5 overflow-hidden'>
          <Editor 
            height="100%" 
            language={language}  
            theme='vs-light'
            defaultValue={CODE_SNIPPETS[language]}
            value={value}
            onMount={onMount}
            onChange={(value) => setValue(value)}
            options={{
              wordWrap: "on", 
              minimap: { enabled: false }, 
              scrollBeyondLastLine: false, 
              horizontal: "hidden",
              scrollbar: {
                alwaysConsumeMouseWheel: false,
              }
            }}
          />
        </div>
        
        <div className='h-[400px] sm:h-[480px] lg:h-[580px] w-full lg:w-2/5 flex flex-col gap-2'>
          <div className='w-full bg-gray-300 h-20 rounded-md p-1'>
            <textarea className='w-full h-full bg-gray-300 text-black outline-none p-2 resize-none rounded-md placeholder-gray-800 placeholder:font-medium' placeholder='Write your input'></textarea>
          </div>
          <div className='w-full bg-gray-300 flex-1 p-2 rounded-md flex flex-col min-h-0'>
            <div className='font-medium h-6'>Output</div>
            <div className='flex-1 min-h-0 w-full mt-1'>
              {loading ? (
                <div className='flex w-full h-full justify-center items-center'>
                  <CircularProgress size="60px" color='black'/>
                </div>
              ) : (
                <pre className='w-full h-full overflow-y-auto bg-gray-200 p-2 rounded'>{response?.result}</pre>
              )}
            </div>
          </div>
        </div>
       {showPopup && (<RefineCodeEditor
          refinedCode={refinedCode}
          language={language}
          setShowPopup={setShowPopup}
          setValue={setValue}
          setLoadingCard={setLoadingCard}
        />)}
        <Chatbot/>  
        <TemporaryDrawer open={drawerOpen} toggleDrawer={toggleDrawer} setEditorValue={setValue} setLanguage={setLanguage} setResponse={setResponse}/>
      </div>
    </div>
   
    </>
  );
};

export default Compiler;